import React from 'react';
import CategoryNavigation, {
  IExpandedCategoryInfo
} from '@Client/runner.nav.categories/components/CategoryNavigation';
import KendoReactDropDownTree from '@Shared.Angular/kendo.react/KendoReactDropDownTree';
import { ITreeCategory } from '@Client/runner.services/runner.category-navigation.service';

type Props = {
  categorisedItems: ITreeCategory<any>[];
  /**
   * @deprecated The containing component should add the "All" category
   * and pass it in as part of categorisedItems.
   */
  addAllCategory?: boolean;
  defaultItemId?: string;
  /**
   * @deprecated The containing component should add the "Recently Viewed" category
   * and pass it in as part of categorisedItems.
   */
  recentlyViewed?: string;
  onCategoryClick: (
    id: string,
    index?: string,
    name?: string,
    expanded?: IExpandedCategoryInfo
  ) => void;
  selectedCategoryId: string;
  expandedCategory?: IExpandedCategoryInfo;
};
export const Category = (props: Props) => {
  const {
    categorisedItems,
    addAllCategory,
    defaultItemId,
    recentlyViewed,
    onCategoryClick,
    selectedCategoryId,
    expandedCategory
  } = props;

  const categories = [
    ...(addAllCategory
      ? [{ text: 'All', id: defaultItemId, flowModels: [], items: [] }]
      : []),
    ...(recentlyViewed
      ? [
          {
            text: 'Recently Viewed',
            id: recentlyViewed,
            flowModels: [],
            items: []
          }
        ]
      : []),
    ...categorisedItems
  ];

  return (
    <div className={`category-selector`}>
      <link
        href="https://kendo.cdn.telerik.com/themes/7.0.1/material/material-main.css"
        rel="stylesheet"
        type="text/css"
      />
      <KendoReactDropDownTree
        categories={categories}
        categoryClicked={onCategoryClick}
        selectedId={selectedCategoryId}
        defaultItemId={defaultItemId}
      />
      <div className="categories-col">
        <h4 className="pl-15">
          <b>Categories</b>
        </h4>
        <CategoryNavigation
          categories={categories}
          categoryClicked={onCategoryClick}
          selectedCategoryId={selectedCategoryId}
          expandedCategoryInfo={expandedCategory}
        />
      </div>
    </div>
  );
};
